const Vue = require('vue')
import config from '../config'
import vueresource from 'vue-resource'
import {
  Toast
} from 'vant'
Vue.use(vueresource)

var wxlogin = async function () {
  var appid = config.wx.appid;
  var url = window.location.href;
  let scope = 'snsapi_userinfo' // snsapi_base 静默授权，snsapi_userinfo 弹出授权页面， snsapi_login 网页应用目前仅填写
  window.location.href = 'http://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(url) + '&response_type=code&scope=' + scope + '&state=1#wechat_redirect'
}

const ResultObject = function (response) {
  this._response = response;
  if (this._response.status == 0) {
    this._data = {
      r: false,
      msg: '当前无网络'
    }
    Toast({
      message: '当前无网络'
    })
  }
  if (this._response.status == 401) {
    config.clearUserInfo();
    this._data = {
      r: false,
      code: 401,
      msg: '当前未登录'
    }
    Toast({
      message: '当前未登录'
    })
    // if (config.wx.isWX && !config.wx.code) {
    //   wxlogin();
    // } else {
    // window.location.href = '/login?from=' + window.location.href;
    // }
  }

  if (this._response.ok) {
    this._data = response.body
  }
  if (!this._data) {
    this._data = {
      r: false,
      msg: this._response.statusText
    }
  }
}
ResultObject.prototype = {
  get data() {
    return this._data.data;
  },
  get R() {
    return this._data.r;
  },
  get msg() {
    return this._data.errmsg || this._data.msg;
  },
  get code() {
    return this._data.code;
  }
}

export default {
  // post提交
  postbase: function (url, params, showloadding) {
    let toast = null;
    if (showloadding) {
      toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '加载中...'
      })
    }

    if (url.indexOf("http") < 0) {
      url = config.apihost + url;
    }

    return Vue.http.post(url, params, {
      headers: {
        'Authorization': `Bearer ${config.userinfo.token}`,
        'X-Requested-With': 'XMLHttpRequest',
        'SystemCode': 'onenet_h5'
        // 'Content-Type':'application/x-www-form-urlencoded'
      },
      emulateJSON: false,
      withCredentials: true
    }).then(function (response) {
      if (toast)
        toast.clear()
      var obj = new ResultObject(response)
      return obj
    }, function (response) {
      if (toast)
        toast.clear()
      var obj = new ResultObject(response)
      return obj
    })
  },
  putbase: function (url, params, showloadding) {
    let toast = null;
    if (showloadding) {
      toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '加载中...'
      })
    }

    if (url.indexOf("http") < 0) {
      url = config.apihost + url;
    }
    return Vue.http.put(url, params, {
      headers: {
        'Authorization': `Bearer ${config.userinfo.token}`,
        'X-Requested-With': 'XMLHttpRequest',
        // 'Content-Type':'application/x-www-form-urlencoded'
      },
      emulateJSON: false,
      withCredentials: true
    }).then(function (response) {
      if (toast)
        toast.clear()
      var obj = new ResultObject(response)
      return obj
    }, function (response) {
      if (toast)
        toast.clear()
      var obj = new ResultObject(response)
      return obj
    })
  },
  // post提交，显示 加载中...
  post: function (url, params, showLoading) {
    if (showLoading == undefined) {
      showLoading = true;
    }
    return this.postbase(url, params, showLoading)
  },
  put: function (url, params, showLoading) {
    if (showLoading == undefined) {
      showLoading = true;
    }
    return this.putbase(url, params, showLoading)
  },
  getblob: function (url) {
    const toast = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '加载中...'
    })

    return Vue.http.get(url, {
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${config.userinfo.token}`,
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      toast.clear()
      return response.blob()
    }, function (response) {
      toast.clear()
      return response.blob()
    })
  },
  get: function (url, p, showloading) {
    if (showloading == undefined) {
      showloading = true;
    }
    let toast = null;
    if (showloading) {
      toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '加载中...'
      })
    }

    if (url.indexOf("http") != 0) {
      url = config.apihost + url;
    }
    return Vue.http.get(url, {
      params: p,
      headers: {
        'Authorization': `Bearer ${config.userinfo.token}`,
        'X-Requested-With': 'XMLHttpRequest'
      },
      withCredentials: true
    }).then(function (response) {
      if (showloading)
        toast.clear();
      var obj = new ResultObject(response)
      return obj
    }, function (response) {
      if (showloading)
        toast.clear()
      var obj = new ResultObject(response)
      return obj
    })
  }
}
